import { notification } from 'antd';
import React, { useState } from 'react';
import apiService from '../../axios/apiService';
import CaseForm from './Forms/CaseForm';
import { useGetCase } from '../../hooks/cases/useGetCase';
import { useLocation, useNavigate } from 'react-router-dom';
import { BAD_REQUEST_STATUS_CODE } from '../../axios/constants';
import { AxiosError } from 'axios';
import { getSearchParamFromLocation } from '../../utils/mapper';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/created' },
  { label: 'Edit', to: '/user/case/edit' },
];
const EditCase = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [api, contentHolder] = notification.useNotification();
  const { data, loading: loadingCase } = useGetCase();
  const location = useLocation();
  const caseId = getSearchParamFromLocation('id', location);

  const handleSubmit = async (data, _loading = 'saving') => {
    setLoading(_loading);
    try {
      const id = getSearchParamFromLocation('id', location);
      const response = await apiService.updateCase(id, data);
      api.success({
        message: 'Success',
        description: response?.message,
        showProgress: false,
      });
      setTimeout(() => {
        navigate('/user/case/created');
      }, 300);
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error?.response?.status === BAD_REQUEST_STATUS_CODE &&
        !error?.response?.data?.formErrorMessage
      )
        return;
      api.error({
        message: 'Error',
        description: error.response.data?.error || error?.message,
        showProgress: false,
      });
    } finally {
      setLoading(undefined);
    }
  };

  return (
    <>
      {contentHolder}
      <CaseForm
        initialValues={data}
        loading={loading || loadingCase}
        onSubmit={handleSubmit}
        breadCrumbs={BREAD_CRUMBS}
        caseId={caseId ? Number(caseId) : undefined}
      />
    </>
  );
};

export default EditCase;
